const ITEMS = [
  "Practical Options Strategies",
  "Probability of Profit above 90% Setups",
  "12 Training Batches Completed",
  "SAATH Trainings",
  "Returns Not Guaranteed — Disciplined Risk Management",
  "9 Years Trading Experience",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-[#1C1B1A] bg-[#1C1B1A] py-4"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center whitespace-nowrap font-mono text-xs uppercase tracking-[0.2em] text-[#FAF7F2]/90 sm:text-sm"
              >
                <span className="px-6">{item}</span>
                <span className="text-[#E05A10]">•</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
